var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"uk-margin-top uk-align-right uk-icon-link",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_c('span',{attrs:{"uk-icon":"icon: arrow-left"}}),_vm._v(" Volver atrás")])
}
var staticRenderFns = []

export { render, staticRenderFns }